import React from 'react';
import PropTypes from 'prop-types';

import { SpacerVertical } from '@klarna/bubble-ui';

import { defaultContainerPropTypes, MOET_CONSTANTS } from 'moet-core';
import { generateCyElemId } from 'moet-test-utils/cypress/utils';

import { ContainerTemplate, CallToActionButton, PreAssessmentSummary } from '@/components';
import { PRE_ASSESSMENT_STATUSES } from '@/constants';

import { PreAssessmentStatusAlert } from './PreAssessmentStatusAlert';
import { CY_PRE_ASSESSMENT_OVERVIEW_CONTAINER_IDS } from './constants';

const { ONBOARDING_STATUSES_V2 } = MOET_CONSTANTS;
const tPrefix = 'products-fe.containers.pre_assessment_overview';

export class PreAssessmentOverview extends React.Component {
  constructor(props) {
    super(props);

    this.onNext = this.onNext.bind(this);

    props.initFlow();
  }

  onNext() {
    const { onNext, mid, preAssessment } = this.props;
    const { isSubmitted, showOverview, ...preAssessmentDetails } = preAssessment;

    onNext({
      scrollBeforeNext: true,
      payload: {
        params: { mid },
        body: preAssessmentDetails,
      },
    })
      .then(() => this.props.initFlow())
      .catch(console.error);
  }

  render() {
    const {
      tMerchantAware,
      preAssessment,
      selectedProducts,
      goToStep,
      underwritingStatus,
      isDisabled,
      isLoading,
      merchantStatus,
    } = this.props;

    const isRejected =
      merchantStatus === ONBOARDING_STATUSES_V2.PRE_ASSESSMENT_PENDING &&
      underwritingStatus === PRE_ASSESSMENT_STATUSES.REJECTED;

    const shouldShowChangeButton =
      (merchantStatus === ONBOARDING_STATUSES_V2.PRE_ASSESSMENT_PENDING &&
        [PRE_ASSESSMENT_STATUSES.UNRESOLVED, PRE_ASSESSMENT_STATUSES.STARTED].includes(
          underwritingStatus,
        )) ||
      isRejected;

    return (
      <ContainerTemplate
        title={tMerchantAware(`${tPrefix}.title`)}
        subtitle={tMerchantAware(`${tPrefix}.subtitle_${underwritingStatus}`)}
      >
        {underwritingStatus && <PreAssessmentStatusAlert underwritingStatus={underwritingStatus} />}
        <PreAssessmentSummary
          preAssessment={preAssessment}
          selectedProducts={selectedProducts}
          t={tMerchantAware}
          edit={goToStep}
        />
        {shouldShowChangeButton && (
          <>
            <SpacerVertical spaceToken="space/600" />
            <CallToActionButton
              onClick={this.onNext}
              disabled={isDisabled}
              loading={isLoading}
              {...generateCyElemId(CY_PRE_ASSESSMENT_OVERVIEW_CONTAINER_IDS.BTN_NEW, window)}
            >
              {tMerchantAware(`${tPrefix}.buttons.${isRejected ? 'new_case' : 'change'}`)}
            </CallToActionButton>
          </>
        )}
      </ContainerTemplate>
    );
  }
}

PreAssessmentOverview.propTypes = {
  ...defaultContainerPropTypes,
  goToStep: PropTypes.func.isRequired,
  merchantStatus: PropTypes.string.isRequired,
  preAssessment: PropTypes.object.isRequired,
  selectedProducts: PropTypes.array.isRequired,
  tMerchantAware: PropTypes.func.isRequired,
  underwritingStatus: PropTypes.string,
};
